export const GET_PERSON_OF_CONCERN = '/get_buv';
export const GET_SINGLE_PERSON_OF_CONCERN = '/get_single_buv';
export const UPDATE_PERSON_OF_CONCERN = '/update_buv';
export const CREATE_PERSON_OF_CONCERN = '/create_buv';
export const REMOVE_PERSON_OF_CONCERN = '/remove_buv';
export const GET_LAND_CLASSIFICATIONS = 'buv/get_land_classification_list';
export const GET_SUB_CLASSICATION_LIST = 'buv/get_sub_classification_list';
export const GET_LOCATION_LIST = 'buv/get_location_list';
export const GET_ORDINANCE_REVISION = 'buv/get_ordinance_revision_list';
export const GET_DISTRICT_LIST = 'buv/get_district_list';

export const FORM_DATA = {
  first_name: '',
  middle_name: '',
  last_name: '',
  suffix: '',
  is_approver: 0,
  is_recommender: 0,
  is_assessor: 0,
};

export const EXTENSION_NAMES = [
  { label: '- Select -', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];